import { WorkflowType } from '../../../enums';
import { Workflow, WorkflowReference } from '../../../types';

type WorkflowOption = Pick<Workflow, 'id' | 'workflowType'>;

const createUniqueOptionId = (type: WorkflowType, id: number) => `${type}-${id}`;

const createOption = (
  optionType: WorkflowType,
  workflow: WorkflowOption,
  workflowReference: WorkflowReference,
) => ({
  label: optionType === WorkflowType.PUBLISHED ? 'Published' : 'Draft',
  id:
    workflow.workflowType === optionType
      ? createUniqueOptionId(workflow.workflowType, workflow.id)
      : createUniqueOptionId(workflowReference?.workflowType, workflowReference?.id),
});

export const createWorkflowTypeOptions = (
  workflow: WorkflowOption,
  workflowReference?: WorkflowReference,
) =>
  workflowReference
    ? [
        // always show published, then draft workflow
        createOption(WorkflowType.PUBLISHED, workflow, workflowReference),
        createOption(WorkflowType.DRAFT, workflow, workflowReference),
      ]
    : [];
